import store from '@/store';
import { roleInMerchant, roleInCurrentOrganisation } from './roleInMerchant';

export default function hasPermissionInMerchant(permission, merchantId) {
  const roleInOrganisation = roleInCurrentOrganisation();

  if (store.getters['user/incognito'] || roleInOrganisation === 'owner') {
    return true;
  }

  const merchantPermissions = JSON.parse(localStorage.getItem(`merchantPermissions.${merchantId}`));

  return (merchantPermissions && merchantPermissions[permission] && merchantPermissions[permission].includes(roleInOrganisation));
}
